import dayjs from 'dayjs'
import { mapReceivementStatus } from 'src/utils/mappers/mapReceivementStatus'
import { ReceivementResponse, Receivement } from './ReceivementOverviewListTypes'

export const mapReceivement = (receivement: ReceivementResponse): Receivement => ({
  id: receivement.idRecebimento,
  listNumberArId: receivement.arIds.join(', '),
  startedAt: receivement.dtInicioRecebimento
    ? dayjs(receivement.dtInicioRecebimento).subtract(3, 'hour')
    : undefined,
  status: mapReceivementStatus(receivement.status),
  supplierName: receivement.fornecedor.nmFornecedor,
  fulfillmentCenterId: receivement.fulfillmentCenter?.id ?? undefined,
  fulfillmentCenterName: receivement.fulfillmentCenter?.name ?? 'Recebimento sem FC',
})
